<section class="the-system-wrapper" *ngIf="!userLoggedIn">
  <!-- ================= SECTION 1: THE SYSTEM ================= -->
  <div class="system-container container-fluid container-max py-5 mb-5">
    <div class="row align-items-center p-lg-0 px-4 px-md-5">
      <!-- Left Column: Description & Action Buttons -->
      <div class="col-12 col-lg-4">
        <div class="system-intro">
          <h2 class="system-title mb-3 f80">THE SYSTEM</h2>
          <h3 class="system-title hf mb-3 f40">HERE’S HOW IT WORKS</h3>
          <p class="system-lead mb-4 f18 text-white">
            The more you've done, and the harder it was, the higher your score. This means your level is calculated by two things:
          </p>

          <div class="system-track mb-4">
            <h4 class="track-title f24">System One:</h4>
            <p class="track-desc f16 text-white">Measures how many sports you’ve completed across the four elements: Air, Earth, Water and Ice.</p>
          </div>

          <div class="system-track mb-5">
            <h4 class="track-title f24">System Two:</h4>
            <p class="track-desc f16 text-white">A point measurement of how extreme each sport (and your specific actions within it) is.</p>
          </div>

          <div class="system-actions d-flex flex-column gap-3">
            <button class="hero-btn primary text-uppercase f16" (click)="onEvaluateClick()">EVALUATE MY LEVEL</button>
            <a href="javascript:void(0)" class="hero-btn ghost text-uppercase f16 text-center" (click)="onExploreClick($event)"> EXPLORE SPORTS </a>
          </div>
        </div>
      </div>

      <!-- Right Column: Grid of Levels (3x2 Layout) -->
      <div class="col-12 col-lg-8">
        <div class="row row-cols-1 row-cols-md-3 g-5">
          <!-- Diamond -->
          <div class="col col-lg-4 col-md-6">
            <div class="level-card text-center">
              <div class="level-img-wrap mb-3">
                <img src="assets/images/home/diamond.png" alt="Diamond level badge" class="level-img img-fluid" />
              </div>
              <h3 class="level-name hf mb-2 f40">DIAMOND</h3>
              <p class="level-desc f16 text-white">One sport in one element</p>
            </div>
          </div>

          <!-- Double Diamond -->
          <div class="col col-lg-4 col-md-6">
            <div class="level-card text-center">
              <div class="level-img-wrap mb-3">
                <img src="assets/images/home/doubledaimond.png" alt="Double Diamond level badge" class="level-img img-fluid" />
              </div>
              <h3 class="level-name hf mb-2 f40">DOUBLE DIAMOND</h3>
              <p class="level-desc f16 text-white">Two sports across two elements, but one of these sports must be valued at a minimum of 70pts.</p>
            </div>
          </div>

          <!-- Triple Diamond -->
          <div class="col col-lg-4 col-md-6">
            <div class="level-card text-center">
              <div class="level-img-wrap mb-3">
                <img src="assets/images/home/tripleddiamond.png" alt="Triple Diamond level badge" class="level-img img-fluid" />
              </div>
              <h3 class="level-name hf mb-2 f40">TRIPLE DIAMOND</h3>
              <p class="level-desc f16 text-white">
                Three sports across three elements, but one of these sports must be valued at a minimum of 80pts.
              </p>
            </div>
          </div>

          <!-- Xtreme -->
          <div class="col col-lg-4 col-md-6">
            <div class="level-card text-center">
              <div class="level-img-wrap mb-3">
                <img src="assets/images/home/xtreme.png" alt="Xtreme level badge" class="level-img img-fluid" />
              </div>
              <h3 class="level-name hf mb-2 f40">XTREME</h3>
              <p class="level-desc f16 text-white">Four sports across four elements, but one of these sports must be valued at a minimum of 90pts.</p>
            </div>
          </div>

          <!-- Joker -->
          <div class="col col-lg-4 col-md-6">
            <div class="level-card text-center">
              <div class="level-img-wrap mb-3">
                <img src="assets/images/home/xtreme.png" alt="Joker level badge" class="level-img img-fluid" />
              </div>
              <h3 class="level-name hf mb-2 f40">JOKER</h3>
              <p class="level-desc f16 text-white">
                Four sports across four elements, but at least one sport in each element must have a minimum score of 90pts.
              </p>
            </div>
          </div>

          <!-- Ace -->
          <div class="col col-lg-4 col-md-6">
            <div class="level-card text-center">
              <div class="level-img-wrap mb-3">
                <img src="assets/images/home/xtreme.png" alt="Ace level badge" class="level-img img-fluid" />
              </div>
              <h3 class="level-name hf mb-2 f40">ACE</h3>
              <p class="level-desc f16 text-white">
                Four sports across four elements, but at least one sport in each element must have a minimum score of 100pts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= SECTION 2: THE UNIFORM ================= -->
  <div
    class="uniform-container py-5 mt-5"
    style="background-image: url('assets/images/home/hatbg.png'); background-position: center; background-repeat: no-repeat; background-size: cover"
  >
    <div class="container-fluid container-max position-relative">
      <!-- Red Painted Stroke Background Overlay -->
      <div class="uniform-bg-stroke"></div>

      <div class="row align-items-center uniform-row p-lg-0 px-4 px-md-5">
        <!-- Left Column: Content -->
        <div class="col-12 col-md-7 position-relative z-3">
          <div class="uniform-info">
            <h2 class="uniform-title hf f80 mb-3">THE UNIFORM</h2>
            <h4 class="uniform-subtitle hf f40 mb-4">XDGE is worn only after it's earned.</h4>
            <p class="uniform-desc f16">
              XDGE apparel is not sold as merchandise. It's issued as recognition.<br class="d-none d-lg-block" />
              Each piece represents verified experience, earned progression, and real exposure to risk.<br class="d-none d-lg-block" />
              What you wear tells other athletes where you've been, <b>NOT</b> what you bought.
            </p>
          </div>
        </div>

        <!-- Right Column: Overlapping Cap Image -->
        <div class="col-12 col-md-5 cap-col-wrap">
          <div class="cap-image-wrap">
            <img src="assets/images/home/hat.png" alt="XDGE Baseball Cap" class="cap-img img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
